import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect } from 'react-router-dom'
import Layout from './Layout'
import TaxableAccountsServiceAgreements from '../products/views/TaxableAccountsServiceAgreements'
import * as Views from './views'
import {
  CREATE_NEW_TAXABLE_SERVICES_AGREEMENT_STAGES,
  TaxableAccountsActionItems,
  CreateNewServicesAgreementStage,
  ParticipantFileUploadStageCustodialAccounts,
  PARTICIPANT_FILE_UPLOAD_STAGES_CUSTODIAL_ACCOUNTS,
} from 'config/portal'
const propTypes = {
  match: PropTypes.object.isRequired,
}

const defaultProps = {}
const PARTICIPANT_FILE_UPLOAD_HEADER = 'Open taxable account'
function Routes({ match: { path } }) {
  return (
    <Switch>
      <Route
        exact
        path={path + '/services-agreements'}
        render={(routeProps) => (
          <Layout>
            <TaxableAccountsServiceAgreements {...routeProps} />
          </Layout>
        )}
      />
      <Route
        path={path + '/add-new-services-agreement'}
        render={() => (
          <Layout
            title={TaxableAccountsActionItems.CREATE_NEW_SERVICES_AGREEMENT}
            subject="services agreement"
            currentStage={
              CreateNewServicesAgreementStage.ADD_NEW_SERVICES_AGREEMENT
            }
            stages={CREATE_NEW_TAXABLE_SERVICES_AGREEMENT_STAGES}
          >
            <Views.AddNewServicesAgreementView />
          </Layout>
        )}
      />
      <Route
        path={path + '/select-your-information'}
        render={() => (
          <Layout
            title={TaxableAccountsActionItems.CREATE_NEW_SERVICES_AGREEMENT}
            subject="services agreement"
            currentStage={
              CreateNewServicesAgreementStage.SELECT_COMPANY_INFORMATION
            }
            stages={CREATE_NEW_TAXABLE_SERVICES_AGREEMENT_STAGES}
          >
            <Views.SelectCompanyInformationView />
          </Layout>
        )}
      />
      <Route
        path={path + '/complete-services-agreement'}
        render={() => (
          <Layout
            title={TaxableAccountsActionItems.CREATE_NEW_SERVICES_AGREEMENT}
            subject="services agreement"
            currentStage={
              CreateNewServicesAgreementStage.AGREEMENT_DETAILS_AND_SUBMIT
            }
            stages={CREATE_NEW_TAXABLE_SERVICES_AGREEMENT_STAGES}
          >
            <Views.CompletePlanAgreementView />
          </Layout>
        )}
      />
      <Route
        path={path + '/upload-file'}
        render={() => (
          <Layout
            title={PARTICIPANT_FILE_UPLOAD_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageCustodialAccounts.participantFileUpload
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_CUSTODIAL_ACCOUNTS}
          >
            <Views.UploadParticipantFileView />
          </Layout>
        )}
      />
      <Route
        path={path + '/plan-mapping'}
        render={() => (
          <Layout
            title={PARTICIPANT_FILE_UPLOAD_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageCustodialAccounts.planMapping
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_CUSTODIAL_ACCOUNTS}
          >
            <Views.PlanMappingView />
          </Layout>
        )}
      />
      <Route
        path={path + '/plan-confirmation'}
        render={() => (
          <Layout
            title={PARTICIPANT_FILE_UPLOAD_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageCustodialAccounts.planMapping
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_CUSTODIAL_ACCOUNTS}
          >
            <Views.PlanConfirmationView />
          </Layout>
        )}
      />
      <Route
        path={path + '/review-and-submit-participant-data'}
        render={() => (
          <Layout
            title={PARTICIPANT_FILE_UPLOAD_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageCustodialAccounts.reviewAndSubmit
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_CUSTODIAL_ACCOUNTS}
          >
            <Views.ReviewAndSubmitView />
          </Layout>
        )}
      />
      <Redirect path="*" to={path + '/services-agreements'} />
    </Switch>
  )
}

Routes.propTypes = propTypes
Routes.defaultProps = defaultProps

export default Routes
